import Modal from 'bootstrap/js/dist/modal.js';
import 'bootstrap/js/dist/dropdown.js';

import * as ShoppingCart from './modules/shoppingCart.js';
import './modules/quantity.js';
import {i18n} from './utils.js';

function confirmDelete(submitEvent) {
  const action = $(submitEvent.target).find('[data-action]').data('action');

  const modal = `
    <div class="modal fade">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
              ${i18n(`wishList.${action || 'delete'}.confirmation`)}
            </div>
            <div class="modal-footer flex space-between">
            <button type="button" class="btn btn-danger">${i18n(`wishList.${action || 'delete'}.confirm`)}</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">${i18n(`wishList.${action || 'delete'}.cancel`)}</button>
            </div>
        </div>
      </div>
    </div>
  `;

  // create jquery node
  const $modal = $(modal);
  // append to body
  $('body').append($modal);
  // open modal
  const bsModal = new Modal($modal[0]);
  bsModal.show();
  // set click handler on modal
  $modal.on('click', (e) => {
    $modal.on('hidden.bs.modal', function (e) {
      $modal.remove();
    });
    bsModal.hide();

    if (e.target.classList.contains('btn-danger')) {
      const $form = $(submitEvent.target);
      const url = $form.attr('action');
      const data = $form.serialize();

      $.ajax({
        type: 'POST',
        url: `${url}`,
        data: data,
        success: (data) => {
          location.reload();
        },
        error: (response) => {
          console.log(response);
        },
      });
      return true;
    }

    return false;
  });
}

function addWishlistDialog() {
  const form = document.getElementsByClassName('js-addWishListForm')[0];
  form.parentNode.removeChild(form);
  form.classList.remove('hidden-js');

  const modal = `
    <div class="modal fade">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title">${i18n('wishList.create.new')}</h3>
            </div>
            <div class="modal-body">
              ${form.outerHTML}
            </div>
            <div class="modal-footer flex space-between">
            <button type="button" class="btn btn-link" data-bs-dismiss="modal" aria-label="Close">${i18n('form.cancel')}</button>
            <button type="button" class="btn btn-primary">${i18n('wishList.create.confirm')}</button>
            </div>
        </div>
      </div>
    </div>
  `;

  // create jquery node
  const $modal = $(modal);
  // append to body
  $('body').append($modal);
  // open modal
  const bsModal2 = new Modal($modal[0]);
  bsModal2.show();
  // set click handler on modal
  $modal.on('click', (e) => {
    if (e.target.classList.contains('btn-primary')) {
      $modal.find('form').submit();

      $modal.on('hidden.bs.modal', function (e) {
        $modal.remove();
      });
      bsModal2.hide();
    }
  });
}

function sortChildrenBy(parentSelector, childSelector, filter, order) {
  const $parent = $(parentSelector);
  const $children = $parent.children(childSelector);

  $children.sort(function (a, b) {
    return a
      .getAttribute(filter)
      .localeCompare(b.getAttribute(filter), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
  });

  $children.detach().appendTo($parent);
}

function initWishListSort() {
  const $wishList = $('.wishList-list');
  const $select = $(`
    <div class="form d-inline-flex align-items-center mb-2">
      <div>${i18n('sort.label')}: </div>
      <select name="wishlistSort" id="wishlistSort" class="form-select ms-2">
        <option value="index" selected>${i18n('sort.by.dateAdded')}</option>
        <option value="name">${i18n('sort.by.name')}</option>
        <option value="price">${i18n('sort.by.price')}</option>
        <option value="itemNumber">${i18n('sort.by.itemNumber')}</option>
      </select>
    </div>
  `);

  $wishList.before($select);

  $select.on('change', 'select', (e) => {
    const value = e.currentTarget.value;

    if (value) {
      sortChildrenBy(
        '.wishList-list',
        'li',
        `data-sortable${e.currentTarget.value}`,
        'asc',
      );
    }
  });
}

(function ($) {
  const $addForm = $('.form-addToCart');

  $addForm.on('submit', (e) => {
    ShoppingCart.add(e);
  });

  $('.js-btnAddAll').on('click', (e) => {
    e.preventDefault();

    ShoppingCart.add(e, $addForm);
  });

  $('.js-formWishListDelete').on('submit', (e) => {
    e.preventDefault();

    confirmDelete(e);

    return false;
  });

  $('.js-addWishList').on('click', (e) => {
    e.preventDefault();

    addWishlistDialog();
  });

  initWishListSort();
})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/wishlist.js